const _ = require("lodash");

export default class ServiceMerger {
  constructor(selectedCategoryId) {
    this.selectedCategoryId = selectedCategoryId;
  }

  merge(selectedServices, newServices) {
    const uniqueNewServices = this.getUniqueNewServices(
      newServices,
      selectedServices
    );
    const relevantSelectedServices = this.getRelevantSelectedServices(
      selectedServices,
      newServices
    );

    return this.getUniqueCombinedServices(
      relevantSelectedServices,
      uniqueNewServices
    );
  }

  getUniqueNewServices(newServices, selectedServices) {
    return this.filterDuplicatedServices(newServices, selectedServices);
  }

  filterDuplicatedServices(newServices, selectedServices) {
    return newServices.filter(
      service => !this.isDuplicated(service, selectedServices)
    );
  }

  getRelevantSelectedServices(selectedServices, newServices) {
    return selectedServices.filter(
      service =>
        this.isCategoryMatched(service.gmb_category) ||
        this.isServiceTypeMatched(service.gmb_service_type, newServices)
    );
  }

  isCategoryMatched(gmbCategory) {
    return gmbCategory && gmbCategory.id === this.selectedCategoryId;
  }

  isServiceTypeMatched(gmbServiceType, newServices) {
    return (
      gmbServiceType &&
      newServices.some(service =>
        this.isSameServiceType(gmbServiceType, service.gmb_service_type)
      )
    );
  }

  isSameServiceType(gmbServiceType1, gmbServiceType2) {
    return (
      gmbServiceType1 &&
      gmbServiceType2 &&
      gmbServiceType1.service_type_id === gmbServiceType2.service_type_id
    );
  }

  isDuplicated(service, selectedServices) {
    return selectedServices.some(selectedService =>
      this.isSameServiceType(
        selectedService.gmb_service_type,
        service.gmb_service_type
      )
    );
  }

  getUniqueCombinedServices(relevantSelectedServices, uniqueNewServices) {
    const combinedServices = [
      ...relevantSelectedServices,
      ...uniqueNewServices
    ];
    return _.uniqBy(combinedServices, service =>
      service.gmb_service_type
        ? service.gmb_service_type.service_type_id
        : service.id
    );
  }
}
